module.exports = __webpack_public_path__ + "img/6WeeksOfTheWork.7e6901bc.jpeg";